export enum LinkPaymentStatus {
    CREATED = 'CREATED',
    IN_PROGRESS = 'IN_PROGRESS',
    PAID = 'PAID',
    EXPIRED = 'EXPIRED',
    DELETED = 'DELETED',
    FAILED = 'FAILED',
    PROCESSING = 'PROCESSING',
    PAYMENT_EXECUTING = 'PAYMENT_EXECUTING',
    NONE = 'NONE'
}

export const mapStringToLinkPaymentStatus = (status: string): LinkPaymentStatus => {
    return LinkPaymentStatus[status as keyof typeof LinkPaymentStatus];
};

export const isLinkPaymentStatusFailed = (status: LinkPaymentStatus): boolean => {
    switch (status) {
        case LinkPaymentStatus.PAID:
            return false;
        case LinkPaymentStatus.IN_PROGRESS:
            return false;
        case LinkPaymentStatus.NONE:
            return false;
        default:
            return true;
    }
}

export const isLinkPaymentStatusInProgress = (status: LinkPaymentStatus): boolean => {
    switch (status) {
        case LinkPaymentStatus.CREATED:
            return true;
        case LinkPaymentStatus.IN_PROGRESS:
            return true;
        case LinkPaymentStatus.PROCESSING:
            return true;
        case LinkPaymentStatus.PAYMENT_EXECUTING:
            return true;
        default:
            return false;
    }
}